<template>
  <span :style="{ color }">{{ display }}</span>
</template>

<script>
import { formatDuration } from "@/utils";

export default {
  props: {
    to: [Date, Number, String],
    type: String,
    color: {
      type: String,
      default: "#ED7867",
    },
  },
  data() {
    return {
      endTime: 0,
      display: "",
    };
  },
  watch: {
    to: {
      handler() {
        this.endTime = this.$moment(this.to).valueOf();
        this.start();
      },
      immediate: true,
    },
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    start() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => this.handle(), 1000);
      this.handle();
    },
    handle() {
      const now = this.$moment().valueOf();

      if (now >= this.endTime) {
        clearInterval(this.timer);

        this.formatDisplay(0);
        this.timer = setInterval(() => this.$emit("finish"), 5000);
        this.$emit("finish");
      } else {
        const rest = this.endTime - now;
        this.formatDisplay(rest);
      }
    },
    formatDisplay(rest) {
      if (this.type === "duration") {
        if (rest) {
          this.display = formatDuration(Math.floor(rest / 1000));
        } else {
          this.display = "0秒";
        }
      } else {
        if (rest) {
          this.display = this.$moment(rest).utcOffset(0).format("HH:mm:ss");
        } else {
          this.display = "00:00:00";
        }
      }
    },
  },
};
</script>
